// extracted by mini-css-extract-plugin
module.exports = {"container":"AgeVerification_container__5SCm6"};